import { render, staticRenderFns } from "./add-update-user-role.vue?vue&type=template&id=0a567a38&scoped=true&"
import script from "./add-update-user-role.vue?vue&type=script&lang=js&"
export * from "./add-update-user-role.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a567a38",
  null
  
)

export default component.exports